import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { ReceiptService } from '../../finance/services/receipt.service';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { SharedDirectivesModule } from '../../shared/directives/shared-directives.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../shared/validators/shared-validators.module';
import { CustomerCoreModule } from '../customer-core.module';
import { AccountCreationModalComponent } from './customer-account-creation-modal.component';
import { CustomerAccountDetailsComponent } from './customer-account-details.component';
import { CustomerAccountSummaryComponent } from './customer-account-summary.component';
import { CustomerAccountTransactionSearchComponent } from './customer-account-transaction-search.component';
import { EditCustomerAccountComponent } from './edit-customer-account.component';
import { CustomerAccountServiceModule } from './service/customer-account-service.module';
import { CustomerAccountTransactionsReportComponent } from './customer-account-transactions-report.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        AccountCreationModalComponent,
        CustomerAccountSummaryComponent,
        CustomerAccountDetailsComponent,
        CustomerAccountTransactionsReportComponent,
        CustomerAccountTransactionSearchComponent,
        EditCustomerAccountComponent
    ],
    providers: [
        ReceiptService
    ],
    imports: [
        CalendarModule,
        CommonModule,
        CustomerAccountServiceModule,
        CustomerCoreModule,
        DropdownModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        InputMaskModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerAccountDetailsComponent,
        CustomerAccountSummaryComponent,
        CustomerAccountTransactionSearchComponent,
        CustomerAccountTransactionsReportComponent,
        EditCustomerAccountComponent
    ]
})
export class CustomerAccountModule {}
